/* eslint-disable import/no-anonymous-default-export */
const msg = (state) => state.toast.toast.msg;
const severity = (state) => state.toast.toast.severity;

export default { msg, severity };
